import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const deleteMessages = messageIds =>
    RESTClient.deleteAuthenticatedObservable('v2/messages', {
        messageIds,
    });

export const archiveConversation = conversationId =>
    RESTClient.postAuthenticatedObservable(`v2/conversations/${conversationId}/archive`);

export const unarchiveConversation = conversationId =>
    RESTClient.postAuthenticatedObservable(`v2/conversations/${conversationId}/unarchive`);

export const unreadConversation = conversationId =>
    RESTClient.postAuthenticatedObservable(`v2/conversations/${conversationId}/mark-as-unread`);
